export default __webpack_public_path__ + "static/media/featured.e92bd73c.jpg";